import Component from '../abstracts/Component';
import vex from 'vex-js';

export default class LookbookComponent extends Component {

  get COMPONENTNAME() {
    return 'LookbookComponent';
  }

  get SELECTORS() {
    return {
      carousel: "#carousel",
      card: "[data-js-card]",
      modal: "[data-js-modal]",
      modalCarousel: "[data-js-modal-carousel]",
      productPin: "[data-js-sku]",
      prevArrow: "[data-js-prev-arrow]",
      nextArrow: "[data-js-next-arrow]",
      productInfo: "[data-js-product-info]",
      modalPrevArrow: "[data-js-modal-prev-arrow]",
      modalNextArrow: "[data-js-modal-next-arrow]",
    };
  }

  readDOM() {
    return {
      carousel: this.$component.querySelector(this.SELECTORS.carousel),
      cards: this.$component.querySelectorAll(this.SELECTORS.card),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      productPins: this.$component.querySelectorAll(this.SELECTORS.productPin),
      productInfos: this.$component.querySelectorAll(this.SELECTORS.productInfo),
      modalBgColor: this.$component.dataset.modalBackground,
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  importSlick(carousel, options) {
    const ctx = this;
    const carouselInstance =
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        $(carousel).slick(options);
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  handleCardClick(card, cardModal) {
    const ctx = this;
    const textColor = ctx.dom.modalBgColor == 'black' ? 'white' : '';
    if (!card.classList.contains('swiping')) {
      cardModal.classList.remove("hidden");
      vex.open({
        unsafeContent: cardModal,
        className: `--lookbook --bg-${ctx.dom.modalBgColor} --txt-${textColor}`,
        contentClassName: `--bg-${ctx.dom.modalBgColor}`,
        closeClassName: 'icon-close --l --pointer',
        showCloseButton: true,
        afterOpen: function () {
          this.closeEl.classList.remove("vex-close");
          // init slick for mobile
          const cardCarousel = cardModal.querySelector(ctx.SELECTORS.modalCarousel);
          const options = {
            dots: true,
            arrows: true,
            prevArrow: cardModal.querySelector(ctx.SELECTORS.modalPrevArrow),
            nextArrow: cardModal.querySelector(ctx.SELECTORS.modalNextArrow),
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: true,
                  slidesToShow: 1,
                }
              }
            ]
          };
          ctx.importSlick(cardCarousel, options);
        },
      });
    }
  }

  bindPinClick() {
    if(this.dom.productPins && this.dom.productPins.length > 0) {
      this.dom.productPins.forEach(pin => {
        pin.addEventListener("click", event => {
          event.preventDefault();
          event.stopPropagation();
          const productInfo = pin.querySelector(this.SELECTORS.productInfo);
          productInfo ? productInfo.classList.toggle("hidden") : "";
        });
      });
    }
  }

  bindLinkClick() {
    if(this.dom.productInfos && this.dom.productInfos.length > 0) {
      this.dom.productInfos.forEach(info => {
        info.addEventListener("click", event => {
          event.stopPropagation();
        });
      });
    }
  }

  bindCardClick() {
    this.dom = this.readDOM();
    const dragEndEvents = ['mouseup', 'touchend'];
    if(this.dom.cards) {
      this.dom.cards.forEach(card => {
        const cardModal = card.querySelector(this.SELECTORS.modal);
        if(cardModal) {
          // avoid modal opening after carousel swipe action
          card.addEventListener("dragstart", (e) => {
            // add control class if swiping carousel
            card.classList.add("swiping");
          });
          // both mouse and touch
          dragEndEvents.forEach((dragEndEvent) => {
            card.addEventListener(dragEndEvent, () => {
              // on "dragend", remove control class after click event is handled (they're parallel)
              setTimeout(() => {
                  if (card.classList.contains("swiping")) {
                    card.classList.remove("swiping");
                  }
                }
              , 400);
            });
          });
          card.addEventListener("click", (event) => {
            this.handleCardClick(card, cardModal);
          });
        }
      });
    }
  }

  initMainSlick() {
    const cardNumber = this.dom.cards.length;
    //hide arrows on desktop
    if(cardNumber <= 4 ) {
      this.dom.prevArrow.remove();
      this.dom.nextArrow.remove();
      this.dom.prevArrow = null;
      this.dom.nextArrow = null;
    }
    const options = {
      dots: true,
      arrows: true,
      prevArrow: this.dom.prevArrow,
      nextArrow: this.dom.nextArrow,
      slidesToShow: 4,
      infinite: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            arrows: false,
            slidesToShow: 4.2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.2,
            arrows: false
          }
        }
      ]
    };
    this.importSlick(this.dom.carousel, options);
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    if(this.$component.dataset.editMode !== "true") {
      this.bindCardClick();
      this.bindPinClick();
      this.bindLinkClick();
      this.initMainSlick();
    }
  }
}
